export const FORGET_PASSWORD_URL = 'password-forgot';
export const RESET_PASSWORD_URL = 'password-reset/:token';
export const LOGIN_URL = '';


